import { Component } from 'react';

import { FormattedMessage } from 'react-intl';

import { MoneyWithDecimals } from '../../../../ui/moneyWithDecimals/';
import { Rate } from '../../../../ui/rate';

export class CreditOutstandingMessage extends Component {
    hasFees() {
        const { approvalStatusFeesBalance } = this.props;
        return approvalStatusFeesBalance > 0;
    }

    renderRateMessage() {
        const { approvalInterestRate } = this.props;

        return (
            <FormattedMessage
                id="_.dashboard.approved.credit_utilisation.monthly_interest_rate"
                defaultMessage="{monthlyInterestRate} interest per 30 days"
                values={{
                    monthlyInterestRate: <Rate value={approvalInterestRate} />
                }}
            />
        );
    }

    renderAmountMessage() {
        const { approvalStatusFeesBalance, approvalStatusInterestBalance } =
            this.props;

        if (this.hasFees()) {
            return (
                <FormattedMessage
                    id="_.dashboard.approved.credit_utilisation_outstanding_message_with_interest_and_fees"
                    defaultMessage="You owe {interestBalance} in interest and {feesBalance} in fees"
                    values={{
                        interestBalance: (
                            <MoneyWithDecimals
                                value={approvalStatusInterestBalance}
                            />
                        ),
                        feesBalance: (
                            <MoneyWithDecimals
                                value={approvalStatusFeesBalance}
                            />
                        )
                    }}
                />
            );
        }

        return (
            <FormattedMessage
                id="_.dashboard.approved.credit_utilisation_outstanding_message_with_interest"
                defaultMessage="You owe {interestBalance} in interest"
                values={{
                    interestBalance: (
                        <MoneyWithDecimals
                            value={approvalStatusInterestBalance}
                        />
                    )
                }}
            />
        );
    }

    render() {
        const { className } = this.props;
        const rateMessage = this.renderRateMessage();
        const amountMessage = this.renderAmountMessage();

        return (
            <span
                className={className}
                data-testid="credit-outstanding-message"
            >
                <div>{rateMessage}</div>
                <div>{amountMessage}</div>
            </span>
        );
    }
}
